export default __webpack_public_path__ + "static/Thailand-ab308932834f5c346af569cdaeda9376.png";